import { MenuConfigWithModule } from 'types/route';

import { AppModules, GTMEvents } from 'constants/enums';
import { RECRUITMENT_OVERVIEW_REPORT } from 'constants/path';

import { ReactComponent as Home } from 'assets/icons/home.svg';
import { ReactComponent as Analytics } from 'assets/icons/navmenu-analytics.svg';
import { ReactComponent as Applications } from 'assets/icons/navmenu-applications.svg';
import { ReactComponent as Jobs } from 'assets/icons/navmenu-jobs.svg';
import { ReactComponent as Jobseekers } from 'assets/icons/navmenu-jobseekers.svg';

const menuConfig: MenuConfigWithModule[] = [
  {
    key: 'home',
    label: 'common.label.home',
    path: '/',
    icon: <Home />,
    description: 'common.label.home.description',
    module: null,
    event: GTMEvents.DashboardClickNavHome
  },
  {
    key: 'jobs',
    label: 'common.label.jobs',
    path: '/jobs',
    icon: <Jobs />,
    description: 'common.label.jobs.description',
    module: AppModules.Jobs,
    event: GTMEvents.DashboardClickNavJobs
  },
  {
    key: 'applications',
    label: 'common.label.applications',
    path: '/applications',
    icon: <Applications />,
    description: 'common.label.applications.description',
    module: AppModules.Applications,
    event: GTMEvents.DashboardClickNavApplications
  },
  {
    key: 'jobseekers',
    label: 'common.label.jobseekers',
    path: '/jobseekers',
    icon: <Jobseekers />,
    description: 'common.label.jobseekers.description',
    module: AppModules.Jobseekers,
    event: GTMEvents.DashboardClickNavJobseekers
  },
  {
    key: 'recruitmentOverview',
    label: 'common.label.analytics',
    path: RECRUITMENT_OVERVIEW_REPORT,
    icon: <Analytics />,
    description: 'common.label.analytics.description',
    module: AppModules.RecruitmentOverviewReport,
    event: GTMEvents.DashboardClickNavAnalytics
  }
];

export default menuConfig;
